import {
  Autocomplete,
  InputLabel,
  FormControl,
  OutlinedInput,
  FormHelperText,
  Chip,
  Stack,
} from '@mui/material';
import { FieldProp } from 'react-typed-form';
import { Option } from '../../vendor/mui-devias-kit/components/core/option';

type Props = {
  field: FieldProp<string[]>;
  options: { value: string; label: string }[];
  label?: string;
  placeholder?: string;
  required?: boolean;
  helperText?: string;
  maxTags?: number;
};

export default function FieldTags({
  field,
  options,
  label,
  placeholder,
  required,
  helperText,
  maxTags,
}: Props) {
  return (
    <Stack gap={0.5}>
      <Autocomplete
        multiple
        limitTags={maxTags}
        id="tags-standard"
        options={options}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        value={
          options.filter((option) => field.value?.includes(option.value)) ?? []
        }
        onChange={(_, newValue) => {
          const limitedValue = maxTags ? newValue.slice(0, maxTags) : newValue;
          field.handleValueChange(
            limitedValue.map(
              (option: { value: string; label: string }) => option.value,
            ),
          );
        }}
        renderInput={(params) => (
          <FormControl
            error={field.lastErrorList && field.lastErrorList.length > 0}
            fullWidth
          >
            <InputLabel required={required}>{label ?? field.label}</InputLabel>
            <OutlinedInput
              {...params.InputProps}
              inputProps={params.inputProps}
              label={label ?? field.label}
              placeholder={placeholder}
            />
            {field.lastErrorList &&
              field.lastErrorList.length > 0 &&
              field.lastErrorList.map((error) => (
                <FormHelperText key={error}>{error}</FormHelperText>
              ))}
          </FormControl>
        )}
        renderOption={(props, option) => (
          <Option {...props} key={option.value} value={option.value}>
            {option.label}
          </Option>
        )}
        renderTags={(value, getTagProps) => {
          return value.map((option, index) => (
            <Chip
              label={option.label}
              {...getTagProps({ index })}
              variant="outlined"
            />
          ));
        }}
      />
      {helperText && (
        <FormHelperText sx={{ ml: 1 }}>{helperText}</FormHelperText>
      )}
    </Stack>
  );
}
